module.exports = __webpack_public_path__ + "static/media/ios-checkbox.7bb4da9d.svg";